import React from 'react';

import { normalizeSelectValue, RadioGroup } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const normalizeValue = (value, options) => {
  if (value === undefined) {
    return options[0].id;
  }
  if (options.length === 1) {
    return options[0].id;
  }
  return normalizeSelectValue(value, options);
};
const FormRadioGroup = withFormField({
  normalizeValue,
})(({ area, radioVertical, ...props }) => {
  return (
    <RadioGroup
      {...omitFormProps(props)}
      vertical={radioVertical}
      loading={area.loading}
      options={area.data}
    />
  );
});

export default FormRadioGroup;
